import React, { useEffect } from 'react';
import HomeTemplate from '../components/home/HomeTemplate';
import brokersConfig from '../data/landingPages/brokers.json';
import Seo from '../components/Seo';
import { isPrerendering } from '../utils/prerendering';

/**
 * Public brokers page: supported brokers matrix + account access explainer.
 * Linked from the trade chart when the connected broker lacks market data.
 */
const Brokers = () => {
  useEffect(() => {
    if (isPrerendering()) return;
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Seo
        title="Supported Brokers | PrecisionTrader"
        description="See which brokers PrecisionTrader supports, which include market data, and how we access your account."
        canonicalPath="/brokers"
      />
      <HomeTemplate config={brokersConfig} />
    </>
  );
};

export default Brokers;
